@if (inactiveLab(); as lab) {
  <div
    data-testid="lab-inactive-banner"
    role="alert"
    class="alert alert-warning rounded-md mb-4 flex items-start gap-3 py-3"
  >
    <fa-icon [icon]="['fas', 'box-archive']" class="mt-0.5 shrink-0"></fa-icon>
    <span class="text-sm">
      <span class="font-semibold">{{ lab.display_name }} is inactive.</span>
      Existing sequences and projects stay viewable, but uploads, new projects, and edits are disabled.
    </span>
  </div>
}
